import { apiRequest } from './auth';

export const kpiAPI = {
  // Wskaźniki KPI
  getIndicators: async () => {
    return await apiRequest('/kpi/indicators');
  },

  getIndicatorsByProject: async (project) => {
    return await apiRequest(`/kpi/indicators/project/${encodeURIComponent(project)}`);
  },

  getIndicatorById: async (id) => {
    return await apiRequest(`/kpi/indicators/${id}`);
  },

  createIndicator: async (kpiData) => {
    return await apiRequest('/kpi/indicators', {
      method: 'POST',
      body: JSON.stringify(kpiData),
    });
  },

  updateIndicator: async (id, kpiData) => {
    return await apiRequest(`/kpi/indicators/${id}`, {
      method: 'PUT',
      body: JSON.stringify(kpiData),
    });
  },

  deleteIndicator: async (id) => {
    return await apiRequest(`/kpi/indicators/${id}`, {
      method: 'DELETE',
    });
  },

  // Dane KPI
  getDataByProjectAndKPI: async (project, kpiId) => {
    return await apiRequest(`/kpi/data/project/${encodeURIComponent(project)}/kpi/${kpiId}`);
  },

  getDataByProject: async (project) => {
    return await apiRequest(`/kpi/data/project/${encodeURIComponent(project)}`);
  },

  createData: async (data) => {
    return await apiRequest('/kpi/data', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  deleteData: async (id) => {
    return await apiRequest(`/kpi/data/${id}`, {
      method: 'DELETE',
    });
  },

  // Raporty KPI (arkusze – Uzupełnij raport)
  getReports: async (project = 'MAN') => {
    return await apiRequest(`/kpi/reports?project=${encodeURIComponent(project)}`);
  },

  saveReports: async (project = 'MAN', data) => {
    return await apiRequest('/kpi/reports', {
      method: 'PUT',
      body: JSON.stringify({ project, ...data }),
    });
  },
};

export default kpiAPI;
